import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthContextService } from '@core/auth/context/auth-context.service';
import { TermsAndConditionsService } from '@core/auth/terms-and-conditions.service';
import { SocketSessionService } from '@core/socket/socket-session.service';

export const termsAndConditionsGuard: CanActivateChildFn = async () => {
  const router = inject(Router);
  const termsService = inject(TermsAndConditionsService);
  const authContext = inject(AuthContextService);
  const socketSession = inject(SocketSessionService);

  if (authContext.getAuthType() !== 'external') {
    return true;
  }

  try {
    const accepted = await termsService.checkAccepted();
    if (!accepted) {
      return router.createUrlTree(['/auth/terms-and-conditions']);
    }
    return true;
  } catch {
    socketSession.disconnect();
    authContext.clearAllTokens();
    authContext.clearAuthType();
    return router.createUrlTree(['/auth/login']);
  }
};
